import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import { faExclamationCircle, faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import classNames from 'classnames'
import { Grid } from 'uiComponents/layout'
import { MessageKind } from 'uiComponents/messages'
import { Body, Headline } from 'uiComponents/typography'
import './inlineMessage.scss'

interface InlineMessageProps {
    header?: string
    type: MessageKind
    onClose?: () => void
    className?: string
    children?: React.ReactNode
}

const getIcon = (type: MessageKind) => {
    switch (type) {
        case 'warn':
            return <FontAwesomeIcon icon={faExclamationCircle as IconProp} />
        case 'info':
            return <FontAwesomeIcon icon={faInfoCircle as IconProp} />
        default:
            return <FontAwesomeIcon icon={faExclamationCircle as IconProp} />
    }
}

const InlineMessage: FC<InlineMessageProps> = (props) => {
    const { header, children, type, onClose, className } = props

    return (
        <div className={classNames('inline-message', `inline-message--${type}`, className)}>
            <Grid item={1} className="inline-message__icon">
                {getIcon(type)}
            </Grid>
            <Grid item className="inline-message__body">
                <Grid container>
                    <Grid item={8}>
                        <Headline className="inline-message__headline"  size={6}>
                            {header}
                        </Headline>
                    </Grid>
                    {!!onClose && (
                        <Grid item={4} className="inline-message__close">
                            <FontAwesomeIcon className="inline-message__close-icon" onClick={onClose} icon={faTimes} />
                        </Grid>
                    )}
                    <Grid item={12}>
                        <Body size={2}>{children}</Body>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default InlineMessage
